var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPaperclip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm6.34 14.85c-.54.54-1.24.8-1.94.8s-1.41-.27-1.94-.8a2.758 2.758 0 0 1 0-3.89l1.41-1.41c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1.41 1.41a1.25 1.25 0 0 0 0 1.77c.49.49 1.28.49 1.77 0l2.22-2.22c.61-.61.95-1.43.95-2.3 0-.87-.34-1.68-.95-2.3-1.23-1.23-3.37-1.23-4.6 0L8.29 11.4a2.692 2.692 0 0 0 0 3.79c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0a4.183 4.183 0 0 1 0-5.91l2.42-2.42c.9-.9 2.09-1.39 3.36-1.39s2.46.49 3.36 1.39c.9.9 1.39 2.09 1.39 3.36s-.49 2.46-1.39 3.35l-2.22 2.22z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPaperclip2);
export default __webpack_public_path__ + "static/media/vuesax-bold-paperclip-2.819b430ce163ece813a183f472558c52.svg";
export { ForwardRef as ReactComponent };